import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import runningSvg from './running.svg?url'
import lookingSvg from './looking.svg?url'

const OuterContainer = styled.div`
  margin: auto;
`

const InnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  ${({ $pageCenter }) =>
    $pageCenter &&
    `
    min-height: 100vh;
  `}
  ${({ $modalCenter }) =>
    $modalCenter &&
    `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`

const StyledImage = styled.img`
  margin: auto;
  width: 100%;
  max-width: 150px;
`

const SpinnerWrapper = ({ src, pageCenter, modalCenter, className, size = 150 }) => {
  const { t } = useTranslation('search')
  return (
    <OuterContainer className={className}>
      <InnerContainer $pageCenter={pageCenter} $modalCenter={modalCenter}>
        <StyledImage src={src} alt={t('spinnerAlt')} style={{ width: size }} />
      </InnerContainer>
    </OuterContainer>
  )
}

export const Spinner = ({ ...props }) => <SpinnerWrapper src={runningSvg} {...props} />
export const AiSpinner = ({ ...props }) => <SpinnerWrapper src={lookingSvg} {...props} />
